import React, { useState } from "react";
import { BoldFont, MediumFont } from "../common/Style";
import Login from "./Login";
import SearchTalsTodos from "./SearchTalsTodos";
import GenericModal from "../common/modals/GenericModal";

const MainUnAuth = () => {
  const [showTals, setShowTals] = useState(false);

  return (
    <div
      style={{
        background:
          "linear-gradient(90deg, rgba(41,59,90,0.95) 0%, rgba(123,150,196,0.95) 100%)",
        width: "100%",
        height: `${window.screen.availHeight}px`,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
      }}
    >
      <div style={{ position: "absolute", top: "35px" }}>
        <BoldFont
          onClick={() => setShowTals(!showTals)}
          style={{
            fontStyle: "italic",
            textAlign: "center",
            fontSize: "40px",
            color: "white",
          }}
        >
          ברוכים הבאים
        </BoldFont>
        <MediumFont
          style={{
            textAlign: "center",
            color: "white",
            marginBottom: "100px",
          }}
        >
          למערכת אישורי הגעה וסידורי לאירועים
        </MediumFont>
      </div>
      <Login />

      {showTals && (
        <GenericModal
          init={setShowTals}
          div={<SearchTalsTodos init={setShowTals} />}
        />
      )}
    </div>
  );
};

export default MainUnAuth;
